// Helper functions for currency handling - MUST BE DEFINED FIRST
function getCurrencyForCountry(countryCode) {
  const currencyMap = {
    // North America
    'US': 'USD', 'CA': 'CAD', 'MX': 'MXN', 'BS': 'BSD', 'BB': 'BBD', 'JM': 'JMD', 'TT': 'TTD',
    'BZ': 'BZD', 'CR': 'CRC', 'PA': 'PAB', 'DO': 'DOP', 'HT': 'HTG', 'CU': 'CUP', 

    // South America
    'BR': 'BRL', 'AR': 'ARS', 'CL': 'CLP', 'CO': 'COP', 'PE': 'PEN', 'VE': 'VES', 'UY': 'UYU',
    'PY': 'PYG', 'BO': 'BOB', 'EC': 'USD', 'GY': 'GYD', 'SR': 'SRD',

    // Europe
    'GB': 'GBP', 'IE': 'EUR', 'FR': 'EUR', 'DE': 'EUR', 'IT': 'EUR', 'ES': 'EUR',
    'PT': 'EUR', 'NL': 'EUR', 'BE': 'EUR', 'AT': 'EUR', 'FI': 'EUR', 'GR': 'EUR',
    'CY': 'EUR', 'SK': 'EUR', 'SI': 'EUR', 'LU': 'EUR', 'LV': 'EUR', 'LT': 'EUR', 'EE': 'EUR',
    'PL': 'PLN', 'CZ': 'CZK', 'HU': 'HUF', 'RO': 'RON', 'BG': 'BGN', 'HR': 'EUR',
    'SE': 'SEK', 'NO': 'NOK', 'DK': 'DKK', 'CH': 'CHF', 'IS': 'ISK',
    'RU': 'RUB', 'UA': 'UAH', 'BY': 'BYN', 'MD': 'MDL', 'RS': 'RSD', 'BA': 'BAM',
    'MK': 'MKD', 'AL': 'ALL',

    // Africa
    'ZA': 'ZAR', 'NG': 'NGN', 'KE': 'KES', 'GH': 'GHS', 'TZ': 'TZS', 'UG': 'UGX',
    'RW': 'RWF', 'ZM': 'ZMW', 'MW': 'MWK', 'MZ': 'MZN', 'BW': 'BWP', 'NA': 'NAD',
    'ZW': 'ZWL', 'ET': 'ETB', 'SD': 'SDG', 'EG': 'EGP', 'MA': 'MAD', 'DZ': 'DZD',
    'TN': 'TND', 'LY': 'LYD',
    // West & Central African CFA Franc
    'SN': 'XOF', 'CI': 'XOF', 'BJ': 'XOF', 'BF': 'XOF', 'TG': 'XOF', 'NE': 'XOF', 'ML': 'XOF', 'GW': 'XOF',
    // Central African CFA Franc
    'CM': 'XAF', 'GA': 'XAF', 'CG': 'XAF', 'TD': 'XAF', 'CF': 'XAF', 'GQ': 'XAF',

    // Middle East
    'AE': 'AED', 'SA': 'SAR', 'QA': 'QAR', 'KW': 'KWD', 'OM': 'OMR', 'BH': 'BHD',
    'IR': 'IRR', 'IQ': 'IQD', 'JO': 'JOD', 'LB': 'LBP', 'SY': 'SYP', 'YE': 'YER', 'IL': 'ILS',

    // Asia
    'IN': 'INR', 'PK': 'PKR', 'BD': 'BDT', 'LK': 'LKR', 'NP': 'NPR', 'MM': 'MMK',
    'TH': 'THB', 'VN': 'VND', 'KH': 'KHR', 'LA': 'LAK', 'MY': 'MYR', 'SG': 'SGD',
    'ID': 'IDR', 'PH': 'PHP', 'CN': 'CNY', 'JP': 'JPY', 'KR': 'KRW', 'HK': 'HKD',
    'TW': 'TWD', 'MN': 'MNT', 'UZ': 'UZS', 'KZ': 'KZT', 'KG': 'KGS', 'TJ': 'TJS', 'TM': 'TMT',

    // Oceania
    'AU': 'AUD', 'NZ': 'NZD', 'FJ': 'FJD', 'PG': 'PGK', 'SB': 'SBD', 'TO': 'TOP', 'WS': 'WST', 'VU': 'VUV',

    // Others
    'TR': 'TRY', 'GE': 'GEL', 'AM': 'AMD', 'AZ': 'AZN',
    'AF': 'AFN', 'NP': 'NPR', 'BT': 'BTN', 'MV': 'MVR',

    // Default
    'DEFAULT': 'USD'
  };
  return currencyMap[countryCode.toUpperCase()] || currencyMap['DEFAULT'];
}

function getCurrencySymbol(currency) {
  const symbolMap = {
    'USD': '$', 'CAD': 'C$', 'AUD': 'A$', 'NZD': 'NZ$', 'EUR': '€', 'GBP': '£',
    'JPY': '¥', 'CNY': '¥', 'INR': '₹', 'RUB': '₽', 'KRW': '₩', 'THB': '฿',
    'VND': '₫', 'IDR': 'Rp', 'MYR': 'RM', 'SGD': 'S$', 'PHP': '₱',
    'AED': 'د.إ', 'SAR': '﷼', 'QAR': 'ر.ق', 'KWD': 'د.ك', 'BHD': '.د.ب', 'OMR': 'ر.ع.',
    'ZAR': 'R', 'NGN': '₦', 'GHS': '₵', 'KES': 'KSh', 'TZS': 'TSh', 'UGX': 'USh',
    'BRL': 'R$', 'ARS': '$', 'CLP': '$', 'MXN': '$', 'COP': '$', 'PEN': 'S/',
    'CHF': 'CHF', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'PLN': 'zł', 'CZK': 'Kč',
    'HUF': 'Ft', 'RON': 'lei', 'BGN': 'лв', 'TRY': '₺', 'ILS': '₪', 'XOF': 'CFA', 'XAF': 'FCFA',
    'AFN': '؋', 'PKR': '₨', 'LKR': 'Rs', 'NPR': 'Rs', 'BDT': '৳', 'MVR': 'Rf',
    'DEFAULT': '$'
  };
  return symbolMap[currency] || symbolMap['DEFAULT'];
}

function getCurrencyName(currency) {
  const nameMap = {
    'USD': 'US Dollars', 'CAD': 'Canadian Dollars', 'AUD': 'Australian Dollars', 'NZD': 'New Zealand Dollars',
    'EUR': 'Euros', 'GBP': 'British Pounds', 'JPY': 'Japanese Yen', 'CNY': 'Chinese Yuan',
    'INR': 'Indian Rupees', 'RUB': 'Russian Rubles', 'KRW': 'South Korean Won', 'THB': 'Thai Baht',
    'VND': 'Vietnamese Dong', 'IDR': 'Indonesian Rupiah', 'MYR': 'Malaysian Ringgit', 'SGD': 'Singapore Dollars',
    'PHP': 'Philippine Pesos', 'AED': 'UAE Dirhams', 'SAR': 'Saudi Riyals', 'QAR': 'Qatari Riyals',
    'KWD': 'Kuwaiti Dinars', 'BHD': 'Bahraini Dinars', 'OMR': 'Omani Rials', 'ZAR': 'South African Rand',
    'NGN': 'Nigerian Naira', 'GHS': 'Ghanaian Cedi', 'KES': 'Kenyan Shillings', 'TZS': 'Tanzanian Shillings',
    'UGX': 'Ugandan Shillings', 'BRL': 'Brazilian Real', 'ARS': 'Argentine Pesos', 'CLP': 'Chilean Pesos',
    'MXN': 'Mexican Pesos', 'COP': 'Colombian Pesos', 'PEN': 'Peruvian Sol', 'CHF': 'Swiss Francs',
    'SEK': 'Swedish Krona', 'NOK': 'Norwegian Krone', 'DKK': 'Danish Krone', 'PLN': 'Polish Zloty',
    'CZK': 'Czech Koruna', 'HUF': 'Hungarian Forint', 'RON': 'Romanian Leu', 'BGN': 'Bulgarian Lev',
    'TRY': 'Turkish Lira', 'ILS': 'Israeli New Shekels', 'XOF': 'West African CFA Francs',
    'XAF': 'Central African CFA Francs', 'AFN': 'Afghan Afghani', 'PKR': 'Pakistani Rupees',
    'LKR': 'Sri Lankan Rupees', 'NPR': 'Nepalese Rupees', 'BDT': 'Bangladeshi Taka', 'MVR': 'Maldivian Rufiyaa',
    'DEFAULT': 'US Dollars'
  };
  return nameMap[currency] || nameMap['DEFAULT'];
}

function handlePopup(countryCode, countryName, isProductPage, isCollectionPage) {
  const host = window.location.hostname;
  const popupBackdrop = document.getElementById("geo-popup-backdrop");
  const popup = document.getElementById("geo-popup");
  
  if (!popup || !popupBackdrop) {
    console.warn("Popup elements not found in DOM");
    return;
  }

  const heading = popup.querySelector("h2");
  const body = popup.querySelector("p");
  const button = popup.querySelector("button");
  const closeBtn = popup.querySelector(".close-btn");

  const slug = window.location.pathname + window.location.search;

  // Product page popup - NEW TWO-COLUMN CURRENCY DESIGN
  if (isProductPage && host.includes("meherbaa.in") && countryCode.toUpperCase() !== "IN") {
    console.log("Triggering PRODUCT page popup");
    
    // Hide default button and add store options
    if (button) button.style.display = "none";
    
    // Get user's currency based on country code
    const userCurrency = getCurrencyForCountry(countryCode);
    const currencySymbol = getCurrencySymbol(userCurrency);
    
    // Check if store options already exist
    let storeOptions = popup.querySelector(".store-options");
    if (!storeOptions) {
      storeOptions = document.createElement("div");
      storeOptions.className = "store-options";
      storeOptions.innerHTML = `
        <div class="store-option" data-store="user-currency">
          <span class="store-icon">${currencySymbol}</span>
          <div class="store-title">${userCurrency}</div>
          <div class="store-subtitle">${getCurrencyName(userCurrency)}</div>
        </div>
        
        <div class="store-option" data-store="inr">
          <span class="store-icon">₹</span>
          <div class="store-title">INR</div>
          <div class="store-subtitle">Indian Rupees</div>
        </div>
      `;
      popup.appendChild(storeOptions);
    }
    
    storeOptions.style.display = "flex";
    
    heading.textContent = "Choose Your Currency";
    body.innerHTML = "Select your preferred currency to view prices:";
    
    // Add click handlers for currency options
    const userCurrencyOption = storeOptions.querySelector('[data-store="user-currency"]');
    const inrOption = storeOptions.querySelector('[data-store="inr"]');
    
    userCurrencyOption.onclick = () => {
      window.location.href = `https://www.meherbaa.com${slug}`;
    };
    
    inrOption.onclick = () => {
      popupBackdrop.style.display = "none";
    };
    
    closeBtn.onclick = () => {
      popupBackdrop.style.display = "none";
    };
    
    popupBackdrop.style.display = "block";
    return;
  }

  // Collection page popup - NEW TWO-COLUMN CURRENCY DESIGN
  if (isCollectionPage && host.includes("meherbaa.in") && countryCode.toUpperCase() !== "IN") {
    console.log("Triggering COLLECTION page popup");
    
    // Hide default button and add store options
    if (button) button.style.display = "none";
    
    // Get user's currency based on country code
    const userCurrency = getCurrencyForCountry(countryCode);
    const currencySymbol = getCurrencySymbol(userCurrency);
    
    // Check if store options already exist
    let storeOptions = popup.querySelector(".store-options");
    if (!storeOptions) {
      storeOptions = document.createElement("div");
      storeOptions.className = "store-options";
      storeOptions.innerHTML = `
        <div class="store-option" data-store="user-currency">
          <span class="store-icon">${currencySymbol}</span>
          <div class="store-title">${userCurrency}</div>
          <div class="store-subtitle">${getCurrencyName(userCurrency)}</div>
        </div>
        
        <div class="store-option" data-store="inr">
          <span class="store-icon">₹</span>
          <div class="store-title">INR</div>
          <div class="store-subtitle">Indian Rupees</div>
        </div>
      `;
      popup.appendChild(storeOptions);
    }
    
    storeOptions.style.display = "flex";
    
    heading.textContent = "Choose Your Currency";
    body.innerHTML = "Select your preferred currency to view prices:";
    
    // Add click handlers for currency options
    const userCurrencyOption = storeOptions.querySelector('[data-store="user-currency"]');
    const inrOption = storeOptions.querySelector('[data-store="inr"]');
    
    userCurrencyOption.onclick = () => {
      window.location.href = `https://www.meherbaa.com${slug}`;
    };
    
    inrOption.onclick = () => {
      popupBackdrop.style.display = "none";
    };
    
    closeBtn.onclick = () => {
      popupBackdrop.style.display = "none";
    };
    
    popupBackdrop.style.display = "block";
    return;
  }

  // Homepage/Other pages popup - NEW TWO-COLUMN DESIGN
  const isIndiaSite = host.includes("meherbaa.in");

  // Show popup for non-Indian visitors on meherbaa.in
  if (countryCode && countryCode.toUpperCase() !== "IN" && isIndiaSite) {
    console.log("Triggering HOMEPAGE popup");
    
    // Remove existing button and add store options
    if (button) button.style.display = "none";
    
    // Check if store options already exist
    let storeOptions = popup.querySelector(".store-options");
    if (!storeOptions) {
      storeOptions = document.createElement("div");
      storeOptions.className = "store-options";
      storeOptions.innerHTML = `
        <div class="store-option" data-store="global">
          <span class="store-icon">🌍</span>
          <div class="store-title">Global Store</div>
          <div class="store-subtitle">meherbaa.com</div>
        </div>
        
        <div class="store-option" data-store="india">
          <span class="store-icon">🇮🇳</span>
          <div class="store-title">India Store</div>
          <div class="store-subtitle">meherbaa.in</div>
        </div>
      `;
      popup.appendChild(storeOptions);
    }

    heading.textContent = `You're visiting from ${countryName}`;
    body.innerHTML = "Please choose your preferred store:";
    
    // Add click handlers for store options
    const globalOption = storeOptions.querySelector('[data-store="global"]');
    const indiaOption = storeOptions.querySelector('[data-store="india"]');
    
    globalOption.onclick = () => {
      window.location.href = `https://www.meherbaa.com${slug}`;
    };
    
    indiaOption.onclick = () => {
      popupBackdrop.style.display = "none";
    };

    closeBtn.onclick = () => {
      popupBackdrop.style.display = "none";
    };

    popupBackdrop.style.display = "block";
  } else {
    console.log("Popup NOT triggered - conditions not met");
  }
}

function setupPurchasePopup(countryCode) {
  const isNonIndian = countryCode && countryCode.toUpperCase() !== "IN";
  const isIndiaSite = window.location.hostname.includes("meherbaa.in");
  
  // Only setup purchase popup for non-Indian visitors on meherbaa.in
  if (!(isNonIndian && isIndiaSite)) {
    console.log("Purchase popup not needed - Indian visitor or not on .in site");
    return;
  }

  console.log("Setting up purchase popup for non-Indian visitor on meherbaa.in");

  const popupBackdrop = document.getElementById("geo-popup-backdrop");
  const popup = document.getElementById("geo-popup");
  const heading = popup.querySelector("h2");
  const body = popup.querySelector("p");
  const mainBtn = popup.querySelector("button");
  const closeBtn = popup.querySelector(".close-btn");

  let lastClickedBtn = null;
  let isProceeding = false;

  function showPurchasePopup() {
    // Hide default button
    if (mainBtn) mainBtn.style.display = "none";

    // Get user's currency
    const userCurrency = getCurrencyForCountry(countryCode);
    const currencySymbol = getCurrencySymbol(userCurrency);
    const currencyName = getCurrencyName(userCurrency);

    heading.textContent = "Choose Your Currency";
    body.innerHTML = "Select your preferred currency for checkout:";

    // Create or update store options with two-column currency design
    let storeOptions = popup.querySelector(".store-options");
    if (!storeOptions) {
      storeOptions = document.createElement("div");
      storeOptions.className = "store-options";
      popup.appendChild(storeOptions);
    }

    storeOptions.innerHTML = `
      <div class="store-option" data-action="switch-user-currency">
        <span class="store-icon">${currencySymbol}</span>
        <div class="store-title">${userCurrency}</div>
        <div class="store-subtitle">${currencyName}</div>
      </div>
      
      <div class="store-option" data-action="proceed-inr">
        <span class="store-icon">₹</span>
        <div class="store-title">INR</div>
        <div class="store-subtitle">Indian Rupees</div>
      </div>
    `;
    
    storeOptions.style.display = "flex";

    // Add click handlers for currency options
    const userCurrencyOption = storeOptions.querySelector('[data-action="switch-user-currency"]');
    const inrOption = storeOptions.querySelector('[data-action="proceed-inr"]');

    // User Currency Option - Redirect to meherbaa.com
    userCurrencyOption.onclick = () => {
      window.location.href = `https://www.meherbaa.com${window.location.pathname}`;
    };

    // INR Option - Proceed with current site checkout
    inrOption.onclick = () => {
      if (isProceeding) return;
      isProceeding = true;

      if (lastClickedBtn?.form?.action.includes("/cart/add")) {
        body.innerHTML = "<span style='color: green;'>✅ Product added to cart!</span>";
      } else {
        body.innerHTML = "<span style='color: green;'>✅ Proceeding with your purchase!</span>";
      }
      
      storeOptions.style.display = "none";

      setTimeout(() => {
        popupBackdrop.style.display = "none";
        if (lastClickedBtn?.click) lastClickedBtn.click();
        lastClickedBtn = null;
        isProceeding = false;
      }, 1000);
    };

    closeBtn.onclick = () => {
      popupBackdrop.style.display = "none";
      lastClickedBtn = null;
    };

    popupBackdrop.style.display = "block";
  }

  // Intercept purchase button clicks
  document.body.addEventListener(
    "click",
    (e) => {
      const selectors = [
        'form[action*="/checkout"] [type="submit"]',
        'form[action*="/cart/add"] [type="submit"]',
        'button[name="add"]',
        '#more-payment-options-link',
      ];
      const btn = e.target.closest(selectors.join(", "));
      if (!btn || isProceeding) return;

      if (btn.tagName === "A") {
        e.preventDefault();
        e.stopImmediatePropagation();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }

      lastClickedBtn = btn;
      showPurchasePopup();
    },
    true
  );
}

document.addEventListener("DOMContentLoaded", async function () {
  const input = document.querySelector("#customer-phone");
  const pathname = window.location.pathname;
  const isProductPage = pathname.includes("/products/");
  const isCollectionPage = pathname.includes("/collections/") && !isProductPage;
  const host = window.location.hostname;

  let countryCode = "IN";
  let countryName = "India";
  let iti = null; // Store the intl-tel-input instance

  try {
    const res = await fetch("https://api.ipinfo.io/lite/me?token=8e53f243b26a54");
    const data = await res.json();
    countryCode = data.country_code || "IN";
    countryName = data.country || "India";
    handlePopup(countryCode, countryName, isProductPage, isCollectionPage);
    setupPurchasePopup(countryCode);
  } catch (e) {
    console.error("Geo API error:", e);
    handlePopup(countryCode, countryName, isProductPage, isCollectionPage);
    setupPurchasePopup(countryCode);
  }

  if (input) {
    iti = window.intlTelInput(input, {
      initialCountry: countryCode,
      separateDialCode: true,
      nationalMode: false,
      autoHideDialCode: false,
      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
    });

    setTimeout(() => {
      console.log("intl-tel-input initialized for country:", countryCode);
    }, 1000);

    input.removeAttribute('required');
    input.removeAttribute('pattern');

    const form = document.querySelector(".popup__newsletter");
    if (form) {
      form.addEventListener("submit", function (e) {
        if (!input.value.trim()) {
          e.preventDefault();
          alert("Please enter your phone number");
          input.focus();
          return false;
        }

        try {
          let fullNumber = input.value.trim();
          let rawNumber = fullNumber;

          if (iti) {
            try {
              if (typeof iti.getNumber === 'function') {
                const formattedNumber = iti.getNumber();
                if (formattedNumber && formattedNumber.startsWith('+')) {
                  fullNumber = formattedNumber;
                  console.log("Got formatted number:", formattedNumber);
                } else {
                  const selectedCountryData = iti.getSelectedCountryData();
                  if (selectedCountryData && selectedCountryData.dialCode && rawNumber) {
                    const dialCode = selectedCountryData.dialCode;
                    const digitsOnly = rawNumber.replace(/\D/g, "");
                    if (digitsOnly.startsWith(dialCode)) {
                      fullNumber = `+${digitsOnly}`;
                    } else {
                      fullNumber = `+${dialCode}${digitsOnly}`;
                    }
                    console.log("Manually constructed number:", fullNumber);
                  }
                }
              }
            } catch (err) {
              console.warn("Could not format number, using fallback:", err);
              if (rawNumber && !rawNumber.startsWith('+')) {
                const dialCode = countryCode === 'IN' ? '91' : countryCode === 'US' ? '1' : '1';
                const cleanNumber = rawNumber.replace(/\D/g, '');
                if (cleanNumber) {
                  fullNumber = `+${dialCode}${cleanNumber}`;
                }
              }
            }
          }

          let hiddenPhoneInput = form.querySelector('input[name="contact[phone]"]');
          if (!hiddenPhoneInput) {
            hiddenPhoneInput = document.createElement('input');
            hiddenPhoneInput.type = 'hidden';
            hiddenPhoneInput.name = 'contact[phone]';
            form.appendChild(hiddenPhoneInput);
          }
          hiddenPhoneInput.value = fullNumber;

          const noteField = form.querySelector('input[name="contact[note]"]');
          if (noteField) {
            noteField.value = fullNumber;
          }

          console.log("Phone number being submitted:", fullNumber);
        } catch (error) {
          console.error("Error processing phone number:", error);
        }
      });
    }
  }
});